import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

import moment from "moment";

import CentralDashboardService from "../../services/centraldashboard.service";

Chart.register(ChartDataLabels);

function OBTSCollection() {
  const colors = [
    "rgba(255, 232, 138, 1)",
    "rgba(88, 221, 244, 0.85)",
    "rgba(172, 145, 228, 1)",
    "rgba(236, 137, 214, 1)",
    "rgb(240, 173, 74)",
    "rgb(103, 235, 235)",
    "rgb(202, 88, 105)",
    "rgb(228, 228, 74)",
    "rgb(93, 240, 74)",
    "rgb(103, 145, 235)",
    "rgb(202, 88, 173)",
    "rgb(74, 228, 125)",
  ];

  const [activeYearly, setActiveYearly] = useState(1);

  const [loading, setLoding] = useState(false);

  const [graphData, setGraphData] = useState([]);
  const [mainData, setMainData] = useState([]);

  const fetchRevenueCollection = () => {
    const payload = activeYearly.toString();

    setLoding(true);
    CentralDashboardService.getObtsCollection(payload)
      .then((resp) => {
        if (resp.data) {
          setLoding(false);
          setMainData(resp.data);
          setGraphData(resp.data);
        }
      })
      .catch((e) => console.log(e));
  };

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  useEffect(() => {
    fetchRevenueCollection();
  }, [activeYearly]);

  const generateLast7DaysData = () => {
    if (graphData.length != 0) {
      const data = graphData[0].data1.map((item) =>
        moment(item.amounttype, "YYYY-MM-DD").format("DD-MM-YY")
      );

      return data;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    if (graphData.length != 0) {
      const data = graphData[0].data1.map((itm) => itm.amounttype);
      return data;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 1
      ? generateLast7DaysData()
      : activeYearly === 2
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const allDatasets = Array.isArray(graphData)
    ? graphData.map((item, index) => ({
        label: item.depo.toLowerCase(),
        data: item.data1.map((item) => item.amount),
        backgroundColor: colors[index],
        categoryPercentage: activeYearly === 2 ? 0.2 : 0.34,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        },
        borderSkipped: false,
      }))
    : null;

  const chartData = {
    labels: data,
    datasets: allDatasets,
  };

  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  });

  const footer = (tooltipItems) => {
    let sum = 0;

    sum = tooltipItems.reduce((summ, item) => {
      return summ + item.parsed.y || 0;
    }, 0);

    return `Total Amt: ₹${formatter.format(sum)}\n`;
  };

  const options = {
    type: "bar",
    stacked: true,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const value = context.formattedValue;
            return `${label}: ₹${value}`;
          },
          beforeBody: footer,
        },
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },
      },
      legend: {
        display: true,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          drawOnChartArea: true,
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          drawOnChartArea: true,
        },
        ticks: {
          beginAtZero: true,
        },
        suggestedMin: 0,
        suggestedMax: 10,
        title: {
          display: true,
          text: "Amount (in ₹)",
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">OBTS Collection</div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
      </div>
      <div className="mt-3">
        {loading ? (
          <>
            <div className="loading-area">
              <div
                class="spinner-border "
                style={{ color: "rgb(247, 177, 140)" }}
                role="status"
              >
                <span class="sr-only"></span>
              </div>
              <span>Data is Loading...</span>
            </div>
          </>
        ) : (
          <>
            <Bar data={chartData} options={options} width={600} height={275} />
          </>
        )}
      </div>
    </>
  );
}

export default OBTSCollection;
